import Coolwhip from '../../../coolwhip/assets/js/dist/coolwhip';
import zipForm from './forms/zip-form';
import internetNearMe from './internet-near-me';

import leadForm, { addressQual } from './forms/lead-form';

const CLWP = new Coolwhip();

CLWP.settings = {
  swipeableCards: {
    cardWidths: {
      fiveUpWidth: 202,
    }
  }
};

CLWP.init();
zipForm();
leadForm();
addressQual();
internetNearMe();
